<h1 class="title">{{ current }}</h1>
<div class="crumbs" fxLayout="row" fxLayoutAlign="start center" aria-label="Breadcrumb">
  <a [routerLink]="hideSidebarNavigation ? ['/vt-dashboard'] : ['/dashboard']" style="text-decoration: underline;cursor: pointer;color:#0a58ca"
    class="crumb home">{{ hideSidebarNavigation && account.components.length != 0 ? 'Home' : 'Dashboard' }}</a>
  <div *ngFor="let crumb of crumbs" class="crumb" fxLayout="row" fxLayoutAlign="start center">
    <mat-icon class="chevron" aria-hidden="true">chevron_right</mat-icon>
    <div class="link">{{ crumb }}</div>
  </div>
  <div class="crumb current" fxLayout="row" fxLayoutAlign="start center">
    <mat-icon class="chevron" aria-hidden="true">chevron_right</mat-icon>
    <div class="link">{{ current }}</div>
  </div>
</div>
